import * as React from 'react';
import DatePicker from "react-multi-date-picker"
import { Button, Grid, TextField } from '@mui/material';

import "react-multi-date-picker/styles/colors/green.css"
import FormHelperText from '@mui/material/FormHelperText';
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import useSubmitLock from '../../../../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;


export default function AltaRetardos(props) {
    const { lote } = props
    const { periodo } = props
    const { idempleado } = props
    const { notificacion } = props
    const { idconcepto } = props
    const { obtenerdatolote } = props
    const { datotodoempleado } = props
    const { submitting, runWithSubmitLock } = useSubmitLock()

    const [datearray, setDatearray] = React.useState('')
    const [datearray2, setDatearray2] = React.useState([])
    const [dates, setDates] = React.useState()
    const [horaselect, SetHoraselect] = React.useState(0)
    const fechainicio = periodo.fechainicio + 1
    const fechafin = periodo.fechafin + 1


    const weekDays = ["Dom", "Lun", "Mar", "Mier", "Jue", "Vier", "Sab"]
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]

    const Addaltaretardos = () => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')

        const resul = {
            variant: 'warning',
            msg: 'Debe seleccionar por lo menos una fecha'
        }

        if (datearray[0] === '' || idempleado === '') {
            notificacion(resul)

        } else {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", "application/json");


            var raw = JSON.stringify({
                "idlote": lote,
                "idperiodo": periodo.idperiodo,
                "idempleado": idempleado,
                "codigoempleado": datotodoempleado.codigoempleado,
                "nombrelargo": datotodoempleado.nombrelargo,
                "idtipoincidencia": `${idconcepto}`,
                "fechas": datearray2
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };
            try {
                const response = await fetch(`${REACT_APP_API_URL}/pdim/incidencia`, requestOptions)
                const resultado = await response.json();
                return (notificacion(resultado), obtenerdatolote(lote), setDatearray(''), setDates({}), SetHoraselect(0), setDatearray2([]))
            } catch (error) {
                console.log('Algo salio mal', error);
            }
        }
    })

    const handchange = (date) => {
        setDates(date);
        const fechastring = date.toString();
        setDatearray(fechastring);
    };

    const handchangehora = (event) => {
        SetHoraselect(event.target.value)
    };

    const agregarmasdato = (fecha, hora) => {
        const msg = {
            variant: 'warning',
            msg: 'Campo no completado revisar fecha u hora'

        }
        if (datearray === '' || horaselect === 0) {
            notificacion(msg)
        } else {
            const horas = parseFloat(hora)
            const datoagreagr = [fecha, horas]
            setDatearray2([...datearray2, datoagreagr])
        }
    }
    const vaciararray = () => {
        setDatearray2([])
    }

    return (
        <div><br /><br />
            <Grid container spacing={2} >
                <Grid item>
                    <TextField
                        variant='standard'
                        type='number'
                        value={horaselect}
                        onChange={handchangehora}
                        size={'small'}
                    />
                    <FormHelperText id="outlined-weight-helper-text">Cantidad</FormHelperText>
                </Grid>
                <Grid item>
                    <DatePicker
                        weekDays={weekDays}
                        months={months}
                        mainPosition="top"
                        fixMainPosition={true}
                        calendarPosition={`top-center`}

                        style={{
                            backgroundColor: "aliceblue",
                            height: "40px",
                            borderRadius: "3px",
                            fontSize: "16px",
                            padding: "2px 6px"
                        }}
                        disableYearPicker
                        className="green"
                        value={dates}
                        minDate={fechainicio}
                        maxDate={fechafin}
                        onChange={handchange}
                        format="YYYY-MM-DD"
                        sort
                        plugins={[
                            <DatePanel />
                        ]}
                    />
                    <FormHelperText id="outlined-weight-helper-text">Fecha</FormHelperText>
                </Grid>
            </Grid>

            <br />
            Retardos agregadas:
            {datearray2.length === 0 ? (
                <li>Ninguno</li>
            ) : null
            }
            {

                datearray2.map((row, index) => (
                    <li key={index}>{'Fecha: ' + row[0] + ' - Hora: ' + row[1]}</li>
                ))
            }

            <br />
            <Grid container spacing={2}>
                <Grid item>
                    <Button variant='outlined' onClick={(e) => vaciararray()}> Vaciar lista</Button>
                </Grid >
                <Grid item>
                    <Button variant='outlined' onClick={(e) => agregarmasdato(datearray, horaselect)}> agregar</Button>
                </Grid>
                <Grid item>
                    <Button variant='contained' disabled={submitting} onClick={() => Addaltaretardos()}>Enviar</Button>
                </Grid>
            </Grid>

        </div>
    );
}